<template>
  <div class="myHeader">
    <h1 class="logo">
      <router-link to="/home">
        <img :src="headLogo" />
      </router-link>
    </h1>
    <div class="left_box">
      <!-- 导航 -->
      <div class="nav_box" v-if="!showSearch">
        <router-link :class="{router_link_active:$route.meta.exp==='首页'}" to="/home">首页</router-link>
        <router-link
          :class="{router_link_active:$route.path.indexOf('exhibitions_list')>-1}"
          to="/exhibitions_list"
        >毕业展</router-link>
        <router-link
          :class="{router_link_active:$route.path.indexOf('designer/designer_list')>-1}"
          to="/designer"
        >毕业生</router-link>
         <router-link
          :class="{router_link_active:$route.path.indexOf('work_list')>-1}"
          to="/work_list"
        >作品专栏</router-link>
        <router-link
          :class="{router_link_active:$route.path.indexOf('school_list')>-1}"
          to="/school_list"
        >明星院校</router-link>
        <router-link
          :class="{router_link_active:$route.path.indexOf('home_VR')>-1}"
          to="/home_VR"
        >VR</router-link>
        <router-link
          :class="{router_link_active:$route.path.indexOf('about_us')>-1}"
          to="/about_us"
        >关于在展</router-link>
        <!-- <router-link
            :class="{router_link_active:$route.path.indexOf('help')>-1}"
            to="/help"
        >帮助中心</router-link> -->
        <!-- <router-link
          :class="{router_link_active:$route.path.indexOf('task_hall')>-1}"
          to="/task_hall"
        >任务大厅</router-link>
        <router-link
          :class="{router_link_active:$route.meta.exp.indexOf('设计师模块')>-1}"
          to="/designer"
        >设计师</router-link>
        <router-link
          :class="{router_link_active:$route.path.indexOf('successful_case') > -1}"
          to="/successful_case"
        >成功案例</router-link>
        <router-link
          :class="{router_link_active:$route.path.indexOf('fabric')>-1}"
          to="/fabric"
        >灵感面料</router-link>
        <router-link
          :class="{router_link_active:$route.path.indexOf('school_design')>-1}"
          to="/school_design"
        >设计学院</router-link>-->
        <router-link
          :class="{router_link_active:$route.path.indexOf('copyright_protection')>-1}"
          to="/copyright_protection"
        >版权保护</router-link>
        <!-- <router-link to="/icon" :class="{router_link_active:$route.path.indexOf('icon')>-1}">icon图标</router-link> -->
      </div>
      <!-- 搜索 -->
      <transition name="slide-fade">
        <div class="search_box" v-if="showSearch">
          <span class="my_icon close" @click="clearSearchText"></span>
          <input type="text" v-model="searchText" placeholder="输入搜索的内容" @keyup.enter="search" />
          <i class="my_icon black_search" @click="search"></i>
        </div>
      </transition>
    </div>
    <div class="right_box">
      <!-- 显示搜索框 -->
      <transition name="slide-fade">
        <div class="btn3" v-if="!showSearch" @click="showSearch=true">
          <i class="my_icon black_search"></i>
        </div>
      </transition>
      <!-- 上传按钮 -->
      <div
        class="btn3"
        v-if="info && designer && (info.role ==='UserRoleStudent' || info.role ==='UserRoleTeacher')"
      >
        <i class="my_icon upload"></i>
        <ul class="nav_list">
          <li v-if="info.role ==='UserRoleStudent'">
            <router-link to="/upload_final_design">
              上传毕设
              <img src="@/assets/img/common/hot.png" />
            </router-link>
          </li>
          <li>
            <router-link to="/upload_opus">上传作品</router-link>
          </li>
        </ul>
      </div>
      <!-- <div
        class="btn3"
        v-if="process.env.VUE_APP_CASTLE_URL === '//120.78.79.8:8288/'"
      >{{info && info.user_name}}</div> -->
      <!-- 登录后的菜单 -->
      <div class="btn3" v-if="info">
        <!--        <img class="avater" v-if="designer && designer.designer" :src="designer.designer.headPath || avater" alt />-->

        <img class="avater" :src="info && info.headPath || avater" alt />
        <ul class="nav_list">
          <li>
            <router-link to="/personal_center/homepage">我的主页</router-link>
          </li>
          <li>
            <router-link to="/personal_center/works">我的作品</router-link>
          </li>

          <li>
            <router-link to="/personal_center/homepage_care">我的关注</router-link>
          </li>
          <li>
            <router-link to="/personal_center/account">修改资料</router-link>
          </li>
          <li>
            <a href="javascript:void(0);" @click="exit">退出</a>
          </li>
        </ul>
      </div>
      <!-- 未登录 -->
      <div class="btns" v-else>
        <div class="btn" @click="login">登录</div>
        <div class="btn2" @click="register">注册</div>
      </div>
    </div>
  </div>
</template>

<script>
import headLogo from "@/assets/img/head/headLogo.png";
import avater from "@/assets/img/common/avater.png";
export default {
  name: "messageHeader",
  data() {
    return {
      headLogo: headLogo, //logo
      avater: avater, //头像
      islogin: false, //判断是否登录
      showSearch: false, //是否显示搜索框
      searchText: "" //搜索框内容
    };
  },
  created() {
    this.common.getUserInfo(true).then(res => {
      let params = { user: res && res.id, role: res && res.role };
      if (res) {
        return this.common.getFrontDesigners(params, true);
      }
    });
  },
  computed: {
    info() {
      return this.$store.state.info;
    },
    designer() {
      return this.$store.state.designer;
    },
    loginVisible() {
      return this.$store.state.isLoginDialog;
    }
  },
  methods: {
    /** 退出登录*/
    exit() {
      this.common.exitLogin(this.$route);
    },
    // 点击登录按钮
    login() {
      this.$store.dispatch("setIsLoginDialog", true);
    },
    // 点击注册按钮
    register() {
      this.$store.dispatch("setIsRegisterDialog", true);
    },
    // 搜索按钮点击
    search() {
      if (!this.searchText) return;
      this.showSearch = false;
      this.$router.push({
        name: "search_result",
        query: {
          searchText: this.searchText
        }
      });
    },
    // 搜索框的清除按钮
    clearSearchText() {
      this.SearchText = "";
      this.showSearch = false;
    },
    // 路由跳转
    go(name) {
      this.$router.push({
        name: name
      });
    }
  }
};
</script>

<style lang="scss">
.myHeader {
  display: flex;
  background: #fff;
  height: 70px;
  align-items: center;
  padding: 0 3%;
  .logo {
    a {
      display: block;
      // width: 100px;
      img {
        width: 100%;
      }
    }
  }
  .left_box {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    .nav_box {
      display: flex;
      height: 70px;
      line-height: 70px;
      a {
        display: block;
        font-size: 16px;
        color: $font-gary;
        width: 115px;
        text-align: center;
        height: 100%;
        background: #fff;
      }
      a:last-child {
        margin-right: 0px;
      }
      .router_link_active {
        background: #000;
        color: #fff;
      }
    }
    .search_box {
      display: flex;
      align-items: center;
      span {
        cursor: pointer;
      }
      i {
        cursor: pointer;
      }
      .icon {
        height: 18px;
        cursor: pointer;
        font-size: 18px;
        color: #abadb1;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      input {
        border: none;
        border-left: 1px solid #878787;
        font-size: 14px;
        height: 18px;
        line-height: 18px;
        width: 530px;
        text-indent: 6px;
        margin: 0 10px;
        outline: none;
      }
    }
  }
  //登录
  .right_box {
    display: flex;
  }
  .btns {
    display: flex;
    align-items: center;
  }
  .btn3 {
    width: 70px;
    text-align: center;
    height: 70px;
    line-height: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    cursor: pointer;

    .icon {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 22px;
      color: #abadb1;
    }
  }
  .btn3:hover {
    background: #000;
    color: #fff;
  }
  .btn3:hover .nav_list {
    display: block;
  }
  .btn2,
  .btn {
    display: inline-block;
    width: 90px;
    text-align: center;
    height: 34px;
    line-height: 34px;
    font-size: 16px;
    color: $font-black;
    cursor: pointer;
  }
  .btn2 {
    border: 1px solid #000;
    &:hover {
      background: #000;
      color: #fff;
    }
  }

  .avater {
    width: 38px;
    height: 38px;
    border-radius: 50%;
  }
  .nav_list {
    display: block;
  }
  .nav_list {
    background: #fff;
    position: absolute;
    z-index: 999;
    right: 0;
    top: 70px;
    display: none;
    box-shadow: 0px 0px 15px 0px rgba(189, 195, 203, 0.4);
    li {
      width: 160px;
      height: 48px;
      line-height: 48px;
      border-bottom: 1px solid #eee;
      a {
        display: flex;
        justify-content: flex-start;
        height: 100%;
        width: 100%;
        color: $font-black;
        text-indent: 20px;
        img {
          width: 28px;
          height: 18px;
          vertical-align: top;
          margin-left: 5px;
        }
      }
      a:hover {
        background: #f5f5f5;
      }
    }
  }
  .slide-fade-enter-active {
    transition: all 0.3s ease;
  }
  .slide-fade-leave-active {
    transition: all 0s cubic-bezier(1, 0.5, 0.8, 1);
  }
  .slide-fade-enter,
  .slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
  }
}
</style>
